export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-6 mt-20 text-center">
      <p>&copy; {new Date().getFullYear()} My Portfolio. All rights reserved.</p>
    </footer>
  );
}
